import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {useTranslation} from "react-i18next";
import s from "./MatchMeButton.pcss";

const MatchMeButton = props => {
    const {t} = useTranslation("mentorCard");

    return (
        <button
            className={classNames(s.button, props.className)}
            onClick={props.onClick}
            id={props.id}
        >
            {t("matchAmbassador", "Match me with an ambassador")}
        </button>
    );
};

MatchMeButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
};

MatchMeButton.defaultProps = {
    className: "",
    id: "",
};

export default MatchMeButton;
